import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import ProductDetail from "@/pages/ProductDetail";
import OrderSample from "@/pages/OrderSample";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Manufacturing from "@/pages/Manufacturing";
import PLIEvents from "@/pages/PLIEvents";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AutoReveal } from "@/components/AutoReveal";

function SiteChrome({ children }) {
  const isAdmin = useLocation().pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <AutoReveal />}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteChrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/:slug" element={<CategoryDetail />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/order-sample" element={<OrderSample />} />
            <Route path="/order-sample/:slug" element={<OrderSample />} />
            <Route path="/about" element={<About />} />
            <Route path="/manufacturing" element={<Manufacturing />} />
            <Route path="/pli" element={<PLIEvents />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </SiteChrome>
      </BrowserRouter>
      <Toaster
        theme="light"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            border: "1px solid #D7D4CF",
            color: "#222222",
          },
        }}
      />
    </div>
  );
}

export default App;
